import { STOREFRONT } from '@/lib/utils/translation';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useState } from 'react';
import SelectWithRemoteSearch from '../shared/SelectWithRemoteSearch';
import { env } from '@/constant/configs';
import { useRouter } from 'next/navigation';
import { SelectOptionType } from '@/lib/types/BaseType';
import { City } from '@/lib/types/customer/City';
import { cn } from '@/lib/utils';

type CitiesCardProps = {
  lang: string;
  cardData: any;
  setCityData: (paylaod: any) => void;
  onCitySelect?: (v: SelectOptionType) => void;
  wrapperClassName?: string;
  citySelectRowClasses?: string;
  showCount?: boolean;
  showActionButton?: boolean;
  bgImgPath?: string;
};

const initialSelectOption: SelectOptionType = { id: -1, name: '' };

const CityNavigateCard = (props: CitiesCardProps) => {
  const {
    cardData,
    lang,
    setCityData,
    wrapperClassName,
    citySelectRowClasses,
    showCount = true,
    showActionButton = true,
    onCitySelect,
    bgImgPath = '/hero-section/cities.png',
  } = props;
  const router = useRouter();
  const [selectedCityOption, setSelectedCityOption] =
    useState<SelectOptionType>(initialSelectOption);
  const [totalResOfCities, setTotalResOfCities] = useState<number>(0);

  const t = useTranslations();

  const handleCitySelect = (option: SelectOptionType) => {
    setTotalResOfCities(option?.restaurants_count ?? 0);
    setSelectedCityOption(option);
    if (onCitySelect) {
      onCitySelect(option);
    }
  };

  const navigateToCity = () => {
    if (selectedCityOption.id >= 0) {
      router.push(`/city/${selectedCityOption.slug}`);
    }
  };

  return (
    <div
      className={cn(
        'group relative inline-block h-[300px] w-full rounded-[20px] md:max-w-[600px] lg:max-w-[450px] xl:max-w-[590px]',
        wrapperClassName
      )}
    >
      <div className="relative h-full w-full overflow-hidden rounded-[20px]">
        <Image
          // src={cardData?.my_city?.image_path ?? bgImgPath}
          src={bgImgPath}
          alt={
            cardData?.my_city?.h3?.[lang] ??
            t(STOREFRONT.HOME + '.hero_section.my_city')
          }
          className="object-cover transition-all duration-500 ease-linear group-hover:scale-125"
          fill
        />
      </div>
      <div className="absolute inset-0 rounded-[20px] bg-black opacity-30" />
      <div className="absolute bottom-[25px] left-[20px] right-[30px] z-[30]">
        <h3 className="mb-3 text-h5 font-bold text-white">
          {cardData?.my_city?.h3?.[lang] ??
            t(STOREFRONT.HOME + '.hero_section.my_city')}
        </h3>
        <div
          className={cn(
            'mb-2 flex max-w-[70%] flex-col items-start justify-center space-y-5 xl:flex-row xl:items-center xl:justify-start xl:space-x-2 xl:space-y-0',
            citySelectRowClasses
          )}
        >
          <SelectWithRemoteSearch
            apiEndpoint={env.api_url + '/v1/customer/cities'}
            selectedOption={selectedCityOption}
            onSelect={handleCitySelect}
            paramKey="name"
            placeholder={
              cardData?.my_city?.search_placeholder?.[lang] ??
              t('common.search_city')
            }
            initalParams={{
              is_favourite: 0,
              type: 'restaurant',
            }}
            extraParams={{
              order_by: 'order_index',
              order_dir: 'asc',
              per_page: 30,
            }}
            roundClass="rounded-full"
            inputClass="xl:max-w-[180px]"
            setInitialRemoteData={(data) => {
              const onlyRestaurants = data?.data?.filter(
                (city: City) => city?.type === 'restaurant'
              );
              if (onlyRestaurants.length) {
                setTotalResOfCities(
                  onlyRestaurants.reduce(
                    (acc: number, city: City) =>
                      acc + (city.restaurants_count || 0),
                    0
                  )
                );
              }
              setCityData(data);
            }}
          />
          {showActionButton && (
            <button
              type="button"
              onClick={() => navigateToCity()}
              className="rounded-full border-2 border-primary-700 bg-primary-700 px-[28px] py-1 text-base font-[600] text-white transition-colors hover:bg-white hover:text-primary-700 disabled:opacity-90 disabled:hover:bg-primary-700 disabled:hover:text-white"
            >
              {cardData?.my_city?.search_button_label?.[lang] ?? t('search')}
            </button>
          )}
        </div>
        {showCount && totalResOfCities > 0 && (
          <span className="text-sm text-white">
            {totalResOfCities}{' '}
            {/* {totalResOfCities > 1
              ? t(STOREFRONT.HOME + '.cities.gastrnomies')
              : t(STOREFRONT.HOME + '.cities.gastrnomy')} */}
          </span>
        )}
      </div>
    </div>
  );
};

export default CityNavigateCard;
